import { useCallback, useEffect, useState } from "react";
import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  FormControl,
  Image,
  InputGroup,
  Row,
} from "react-bootstrap";
import flota_img from "../../assets/images/flota-img.svg";

import searchIcon from "../../assets/images/search-icon.svg";
import "./flotas.css";
import { FlotasActions } from "./FlotasActions";
import { useTranslation } from "react-i18next";
import axiosApi from "../../axios/axios-api";
import { TablaVehiculosFlota } from "./TablaVehiculosFlota";
import { LoaderPetroprix } from "../ui/LoaderPetroprix";
import { useDispatch, useSelector } from "react-redux";
import { FlotasInfo } from "./FlotasInfo";
import { isMobile } from "react-device-detect";
import { startLogout } from "../../store/auth";
import { ValidateToken } from "../../helpers/validateToken";
import flota_block_icon from "../../assets/images/warning-bold.svg";
import { SwitchControlKm } from "../ui/SwitchControlKm";
import { ModalControlKM } from "./ModalControlKM";
import { formatTelefono } from "../../helpers/formatTelefono";
import phone_icon from "../../assets/images/phone-icon.svg";
import email_icon from "../../assets/images/email-icon.svg";
import { setIdFlota } from "../../store/auth/thunks";

const URL_GET_VEHICULOS_FLOTA = "flotas/listarVehiculos/";
const URL_GET_INFO_FLOTA = "flotas";

export const FlotasScreen = () => {
  const {
    token,
    email_informacion,
    telefono_informacion,
    flotas,
    idClienteFlota,
  } = useSelector((state) => state.auth);

  const [tel, setTel] = useState(
    telefono_informacion !== null ? telefono_informacion : t("ayuda.telefono")
  );

  const [mail, setMail] = useState(
    email_informacion !== null ? email_informacion : t("ayuda.email")
  );

  const [infoFlota, setInfoFlota] = useState({});
  const [loadingInfoFlota, setLoadingInfoFlota] = useState(true);

  const [hasFlotas, setHasFlotas] = useState(flotas);
  const [controlKM, setControlKM] = useState(
    infoFlota?.reg_km === 1 ? true : false
  );
  const [loadingVehiculos, setLoadingVehiculos] = useState(true);
  const [vehiculosFlota, setVehiculosFlota] = useState([]);
  const [resultadosBusqueda, setResultadosBusqueda] = useState(vehiculosFlota);
  const [busqueda, setBusqueda] = useState("");
  const [filtered, setFiltered] = useState(false);
  const [flotaVehiculos, setFlotaVehiculos] = useState(null);
  const [modalControlShow, setModalControlShow] = useState(false);
  const [isAnyVehicleSelected, setIsAnyVehicleSelected] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const fetchInfoFlota = useCallback(async () => {
    setInfoFlota({});
    setLoadingInfoFlota(true);
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.get(URL_GET_INFO_FLOTA, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        if (response?.data?.code === 200) {
          let data = response.data.data[0];
          setInfoFlota(data);
          setControlKM(data?.reg_km === 1 ? true : false);
          setLoadingInfoFlota(false);
          fetchVehiculosFlotaActiva(data.id_cliente_flota);
          dispatch(setIdFlota(data.id_cliente_flota));
        } else {
          setLoadingInfoFlota(false);
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
      setLoadingInfoFlota(false);
    }
  }, []);

  useEffect(() => {
    if (hasFlotas) {
      fetchInfoFlota();
    }
  }, []);

  const fetchVehiculosFlotaActiva = useCallback(async () => {
    if (!isMobile) {
      document.getElementById("buscadorFlotas").value = "";
    }
    setBusqueda("");
    setResultadosBusqueda([]);
    setVehiculosFlota([]);
    setFiltered(false);
    setLoadingVehiculos(true);
    try {
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        const response = await axiosApi.get(
          URL_GET_VEHICULOS_FLOTA + idClienteFlota,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer " + token,
            },
          }
        );
        if (response?.data?.code === 200) {
          let data = response.data.data;
          setVehiculosFlota(data);
          setLoadingVehiculos(false);
        } else {
          setLoadingVehiculos(false);
        }
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
      setLoadingVehiculos(false);
    }
  }, []);

  // useEffect(() => {
  //   if (hasFlotas && flotaActiva) {
  //     if (flotaVehiculos !== flotaActiva.id_cuenta) {
  //       fetchVehiculosFlotaActiva(flotaActiva.id_cuenta);
  //     }
  //   }
  // }, [flotaActiva, hasFlotas]);

  // useEffect(() => {
  //   dispatch(changeFlota(flotaActiva, token));
  // }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    let value = document.getElementById("buscadorFlotas").value;
    setBusqueda(value);
    filtrar(value);
  };

  const filtrar = (terminoBusqueda) => {
    let result = vehiculosFlota.filter((elemento) => {
      if (
        elemento.matricula
          ?.toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        elemento.tipo_vehiculo
          ?.toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        elemento.tipo_combustible
          ?.toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        elemento.credito_definido
          ?.toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        elemento.credito_consumido
          ?.toString()
          .toLowerCase()
          .includes(terminoBusqueda.toLowerCase()) ||
        ("activo".includes(terminoBusqueda.toLowerCase()) &&
          elemento.activo === 1) ||
        ("inactivo".includes(terminoBusqueda.toLowerCase()) &&
          elemento.activo === 0)
      ) {
        return elemento;
      }
    });
    setResultadosBusqueda(result);
    setFiltered(true);
  };

  const orderData = (asc, index) => () => {
    let data;
    if (!filtered) {
      data = [...vehiculosFlota];
    } else {
      data = [...resultadosBusqueda];
    }

    switch (index) {
      case 0:
        index = "matricula";
        break;
      case 1:
        index = "tipo_vehiculo";
        break;
      case 2:
        index = "tipo_combustible";
        break;
      case 3:
        index = "credito_definido";
        break;
      case 4:
        index = "credito_consumido";
        break;
      case 5:
        index = "activo";
        break;
      default:
        break;
    }

    if (asc) {
      data.sort((a, b) => {
        if (a[index] < b[index]) {
          return -1;
        } else if (a[index] > b[index]) {
          return 1;
        } else if (a[index] === null) {
          return 1;
        } else if (b[index] === null) {
          return -1;
        } else {
          return 0;
        }
      });
    } else {
      data.sort((a, b) => {
        if (a[index] > b[index]) {
          return -1;
        } else if (a[index] < b[index]) {
          return 1;
        } else if (a[index] === null) {
          return 1;
        } else if (b[index] === null) {
          return -1;
        } else {
          return 0;
        }
      });
    }
    filtered ? setResultadosBusqueda(data) : setVehiculosFlota(data);
  };

  useEffect(() => {}, [controlKM]);

  return (
    <>
      <Container className="content-body mt-4 px-4">
        {!isMobile && hasFlotas === "1" && infoFlota?.estado === "2" && (
          <Col
            style={{
              marginTop: "-1em",
              display: "flex",
              flexDirection: "row-reverse",
              marginRight: "3.5em",
            }}
          >
            <div className="flota-bloqueada">
              <img
                src={flota_block_icon}
                alt="flota bloqueada"
                className="flota-bloqueada-icon"
              />
              {t("flotas.alert.flota-bloqueada")}
            </div>
          </Col>
        )}
        <Container>
          <div
            className={`d-flex page-header flotas ${
              hasFlotas === "1" ? "has-flotas" : ""
            } pb-1 ${/*flotaActiva?.activo === "0" ? "mt-2" :*/ "mt-3"}`}
          >
            {hasFlotas === "1" && (
              <>
                {isMobile ? (
                  <Col
                    sm={12}
                    md={{ offset: 3, span: 7 }}
                    className="flotas-actions d-xs-block d-lg-none"
                  >
                    {/* Visibilidad en móviles */}
                    {/* {hasFlotas === "1" && flotaActiva?.activo === "0" && (
                      <Col className="mt-4">
                        <div className="flota-bloqueada">
                          <img
                            src={flota_block_icon}
                            alt="flota bloqueada"
                            className="flota-bloqueada-icon"
                          />
                          {t("flotas.alert.flota-bloqueada")}
                        </div>
                      </Col>
                    )} */}

                    <div style={{ overflowX: "scroll", marginBottom: "1rem" }}>
                      <FlotasInfo
                        infoFlota={infoFlota}
                        loadingInfoFlota={loadingInfoFlota}
                      />
                    </div>
                    {/* {flotaActiva?.activo === "1" && (
                      <Row
                        style={{ overflowX: "scroll", marginBottom: "1rem" }}
                      >
                        <FlotasActions
                          vehicleSelected={isAnyVehicleSelected}
                          setVehicleSelected={setIsAnyVehicleSelected}
                          vehiculos={vehiculosFlota}
                          onChange={fetchVehiculosFlotaActiva}
                        />
                      </Row>
                    )} */}
                  </Col>
                ) : (
                  <>
                    <Col
                      lg={{ span: 4, order: 1 }}
                      className="d-none d-lg-block step12"
                    >
                      <FlotasInfo
                        infoFlota={infoFlota}
                        loadingInfoFlota={loadingInfoFlota}
                      />
                    </Col>
                    <Col
                      lg={{ span: 8, order: 2 }}
                      className="flotas-actions d-none d-lg-block step13"
                    >
                      <FlotasActions
                        vehicleSelected={isAnyVehicleSelected}
                        setVehicleSelected={setIsAnyVehicleSelected}
                        vehiculos={vehiculosFlota}
                        onChange={fetchVehiculosFlotaActiva}
                        tipoCuenta={infoFlota?.tipo_cuenta}
                        idClienteFlota={infoFlota?.id_cliente_flota}
                      />
                    </Col>
                  </>
                )}
              </>
            )}
          </div>
          {hasFlotas === "1" && !isMobile && (
            <Row className="page-header flotas pb-4 mt-3">
              <Col sm={12} lg={3}>
                <Form
                  className="search"
                  onSubmit={handleSearch}
                  autoComplete="off"
                >
                  <InputGroup className="mb-1">
                    <InputGroup.Text style={{ backgroundColor: "#ececec" }}>
                      <img src={searchIcon} alt="" />
                    </InputGroup.Text>
                    <FormControl
                      type="text"
                      placeholder={t("facturas.header.buscador")}
                      className="no-border-left"
                      id="buscadorFlotas"
                      name="searchText"
                      onChange={handleSearch}
                      autoComplete="off"
                    />
                  </InputGroup>
                </Form>
              </Col>
              <Col sm={12} lg={{ span: 3, offset: 6 }} className="text-end">
                {infoFlota?.estado === "1" ? (
                  <SwitchControlKm
                    controlkm={controlKM}
                    setControlKM={setControlKM}
                    onChange={setControlKM}
                    modalControlShow={modalControlShow}
                    setModalControlShow={setModalControlShow}
                  />
                ) : (
                  <></>
                )}
              </Col>
            </Row>
          )}
        </Container>
        <Container className="mt-3 bg-white radius-8">
          <Row
            className={`content-section flotas ${
              hasFlotas === "1" ? "content-has-flotas" : ""
            }`}
            style={{ overflowX: "scroll" }}
          >
            {hasFlotas === "1" ? (
              !loadingVehiculos ? (
                vehiculosFlota.length > 0 ? (
                  <TablaVehiculosFlota
                    vehiculos={filtered ? resultadosBusqueda : vehiculosFlota}
                    token={token}
                    // permisos={flotaActiva?.permisos}
                    estadoFlota={infoFlota?.estado}
                    onChange={fetchVehiculosFlotaActiva}
                    orderData={orderData}
                    onSelectVehicle={setIsAnyVehicleSelected}
                  />
                ) : (
                  <Alert variant="warning" className="mt-5">
                    {t("flotas.table.no-vehiculos")}
                  </Alert>
                )
              ) : (
                <LoaderPetroprix />
              )
            ) : (
              <Row className="no-flota">
                <Col xs={12} lg={12}>
                  <Image src={flota_img} className="flotas-image-info" />
                  <Row className="d-flex flex-column mt-5 flotas-status">
                    <h3 className="flotas-study">{t("flotas.no-flotas.h1")}</h3>
                    <p className="flotas-study">
                      {t("flotas.no-flotas.p.solicitar")}
                    </p>
                  </Row>
                  <Row className="d-flex align-items-center justify-content-center mt-4 py-4">
                    <Col xs={3}>
                      <a href={`tel:${tel}`} className="ayuda-help-link">
                        <img
                          src={phone_icon}
                          alt={t("ayuda.help.phone")}
                          className="ayuda-help-icon"
                        />
                        <span className="ayuda-help-phone">
                          {formatTelefono(tel)}
                        </span>
                      </a>
                    </Col>
                    <Col xs={3}>
                      <a href={`mailto:${mail}`} className="ayuda-help-link">
                        <img
                          src={email_icon}
                          alt={t("ayuda.help.phone")}
                          className="ayuda-help-icon"
                        />
                        <span className="ayuda-help-phone">{mail}</span>
                      </a>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </Row>
        </Container>
      </Container>

      <ModalControlKM
        show={modalControlShow}
        onChange={setControlKM}
        controlkm={controlKM}
        flotaId={infoFlota?.id_cliente_flota}
        value={controlKM}
        onHide={() => setModalControlShow(false)}
      />
    </>
  );
};
